import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

/** Petit badge de confiance « Entreprise vérifiée · Floride, USA ». */
export const TrustBadge = ({ theme = "dark", link = true, className = "" }) => {
  const base =
    "inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-[11px] sm:text-xs font-medium tracking-wide transition-colors";
  const styles =
    theme === "dark"
      ? "border-gold/40 bg-gold/10 text-gold hover:border-gold hover:bg-gold/15"
      : "border-navy/15 bg-[#F8F9FA] text-navy hover:border-gold hover:text-gold";
  const content = (
    <>
      <ShieldCheck size={14} className="shrink-0" />
      Entreprise vérifiée · Floride, USA
    </>
  );
  if (!link) {
    return (
      <span data-testid="trust-badge" className={`${base} ${styles} ${className}`}>
        {content}
      </span>
    );
  }
  return (
    <Link to="/entreprise-verifiee" data-testid="trust-badge" className={`${base} ${styles} ${className}`}>
      {content}
    </Link>
  );
};
